import {h, Fragment} from "preact"
import { HistoryElement, useAppStateSelector } from "@nosto/preact"
import { useEffect, useRef } from "preact/hooks"
import { defaultConfig, popularSearches, DROPDOWN_RECID } from "../config"
import { closeSearch } from "../helpers"

export default function History() {
    const keywordsRef = useRef(null);

    useEffect(() => {
        const handleClick = (e) => {
            if(e.target.closest(".ns-autocomplete-element")) {
                closeSearch();
            }
        }

        if(keywordsRef.current) {
            keywordsRef.current.addEventListener('click', handleClick);
            return () => keywordsRef.current.removeEventListener('click', handleClick);
        }
    }, [])

    return (
        <div class="ns-autocomplete ns-absolute">
            <div class="ns-autocomplete-inner ns-w-100 ns-lg-flex ns-lg-nowrap">
                <div class="ns-keywords-section">
                    <h3 class="ns-section-heading">
                            Popular Searches
                    </h3>
                    <div class="ns-keywords-list ns-flex ns-flex-wrap ns-lg-flex-col" ref={keywordsRef}>
                        {popularSearches.map(item => (
                            <HistoryElement key={item} query={{ query: item }}>
                                {item}
                            </HistoryElement>
                        ))}
                    </div>
                </div>

                <nosto-campaign
                    class="ns-products-section"
                    placement={DROPDOWN_RECID}
                    id={DROPDOWN_RECID}
                >
                    <div class="ns-skeleton-title ns-shimmer" />
                    <div class="ns-product-list ns-grid">
                        {Array.from({ length: 6 }, (_, index) => (
                            <div key={index} class="ns-flex ns-flex-nowrap ns-lg-flex-col">
                                <div class="ns-skeleton-img ns-shimmer"/>
                                <div class="ns-skeleton-details ns-flex ns-flex-col">
                                    <div class="ns-skeleton-name ns-shimmer" />
                                    <div class="ns-skeleton-name2 ns-shimmer" />
                                    <div class="ns-skeleton-price ns-shimmer" />
                                </div>
                            </div>
                        ))}
                    </div>
                </nosto-campaign>
            </div>
        </div>
    )
}
